<div class='cache-notification' [style.backgroundColor]=colorHex [hidden]="!visible">
  <div class="notification">
    <h4><i class="mt-alert cache-alert" title="Song may be unavailable"></i>Oops!</h4>
    <p>We have detected that your computer or phone is running low on space. Song caching has been disabled in the app. <button type="button" (click)="closeClicked()">Dismiss</button></p>
    <a class="close-button" (click)="closeClicked()">X</a>
  </div>
</div>
